import { Box } from '@mui/material'
import { PropsWithChildren, ReactElement } from 'react'

interface DataGridContainerProps extends PropsWithChildren {
  error?: boolean
}

export const DataGridContainer = ({ children, error = false }: DataGridContainerProps): ReactElement => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      sx={{
        border: (theme) => (error ? `1px solid ${theme.palette.error.main}` : '1px solid transparent'),
        borderRadius: '4px', // matches default MUI border radius
      }}
    >
      {children}
    </Box>
  )
}
